import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué se siente durante SAINT®?",
    answer:
      "Cada sesión de SAINT® dura unos minutos. El paciente permanece despierto. La estimulación theta burst se siente como golpes suaves en la cabeza. La mayoría de los pacientes tolera bien las sesiones.",
  },
  {
    question: "¿Cuántas sesiones hay por día?",
    answer:
      "SAINT® administra diez sesiones por día durante cinco días, para un total de 50 sesiones. Cada sesión dura unos minutos con descansos entre sesiones.",
  },
];

export const esWhatToExpect = makeEsArticle({
  slug: "what-to-expect-during-saint-tms",
  title: "Qué esperar durante SAINT® TMS",
  description:
    "Qué esperar durante SAINT® TMS: el día del tratamiento, qué se siente, cuántas sesiones por día, descansos y cómo prepararse para la semana de cinco días.",
  h1: "Qué esperar durante SAINT® TMS",
  breadcrumbLabel: "Qué esperar durante SAINT® TMS",
  shortAnswer:
    "SAINT® se administra durante cinco días consecutivos con diez sesiones por día, para un total de 50 sesiones. Cada sesión dura unos minutos y el paciente permanece despierto. La estimulación theta burst se siente como golpes suaves en la cabeza. Hay descansos entre sesiones. La mayoría de los pacientes tolera bien el tratamiento.",
  keyTakeaways: [
    "SAINT® se administra durante cinco días consecutivos.",
    "Diez sesiones por día, 50 en total.",
    "Cada sesión dura unos minutos.",
    "El paciente permanece despierto.",
    "Hay descansos entre sesiones.",
  ],
  sections: [
    {
      heading: "Antes del tratamiento",
      paragraphs: [
        "Antes de iniciar SAINT®, se realiza una resonancia magnética funcional (fMRI) para localizar el circuito cerebral asociado con la depresión. Esta orientación individualizada es lo que distingue a SAINT® de la TMS convencional.",
      ],
    },
    {
      heading: "Durante la semana de tratamiento",
      paragraphs: [
        "Cada día se administran diez sesiones de estimulación theta burst. Cada sesión dura unos minutos, con descansos entre sesiones. El paciente permanece despierto durante todo el tratamiento.",
        "La estimulación se siente como golpes suaves en la cabeza. La mayoría de los pacientes tolera bien las sesiones.",
      ],
    },
    {
      heading: "Después del tratamiento",
      paragraphs: [
        "Tras completar los cinco días, se programa un seguimiento. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793 para analizar el proceso en detalle.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
